import { Link } from "react-router-dom";
import {
  SignupAdditionalContentBase,
  type SignupAdditionalContentBaseProps,
} from "@core/features/auth";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<
  SignupAdditionalContentBaseProps,
  "renderLoginLink" | "renderTermsAndPrivacy"
>;

export function AuthSignupFormAdditionalContent({ className }: Props = {}) {
  return (
    <SignupAdditionalContentBase
      className={className || "flex flex-col mt-8 gap-4"}
      renderLoginLink={() => (
        <Type variant="caption">
          Already have an account?{" "}
          <Link
            to="/login"
            className="underline hover:text-brand-600 transition-color duration-200"
          >
            Log in
          </Link>.
        </Type>
      )}
      renderTermsAndPrivacy={() => (
        <Type variant="caption">
          By signing up, you agree to our{" "}
          <a
            href="/terms"
            target="_blank"
            className="underline hover:text-brand-600 transition-color duration-200"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="/privacy"
            target="_blank"
            className="underline hover:text-brand-600 transition-color duration-200"
          >
            Privacy Policy
          </a>
        </Type>
      )}
    />
  );
}

export default AuthSignupFormAdditionalContent;

